import type { ReactNode } from 'react';
import { KitsWorkspace } from '../components/evaluation/KitsWorkspace';

/**
 * ADMIN-04 (F19.04) — interview kits, admin redesign batch 2 Option A: suggested questions under each rubric line, so different
 * interviewers gather evidence for the same things (master plan S12). With none chosen, the first opens.
 */
export function InterviewKitsPage(): ReactNode {
  return <KitsWorkspace selectedId={null} />;
}
